'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var DEFAULT_CLASS = 'luna-tab';

var Tab = function (_Component) {
    _inherits(Tab, _Component);

    function Tab() {
        _classCallCheck(this, Tab);

        return _possibleConstructorReturn(this, (Tab.__proto__ || Object.getPrototypeOf(Tab)).apply(this, arguments));
    }

    _createClass(Tab, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkFocus();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.checkFocus();
        }
    }, {
        key: 'checkFocus',
        value: function checkFocus() {
            var _props = this.props,
                selected = _props.selected,
                focus = _props.focus;

            if (selected && focus) {
                this.node.focus();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                disabled = _a.disabled,
                disabledClassName = _a.disabledClassName,
                focus = _a.focus,
                id = _a.id,
                hidden = _a.hidden,
                panelId = _a.panelId,
                selected = _a.selected,
                selectedClassName = _a.selectedClassName,
                tabRef = _a.tabRef,
                attributes = __rest(_a, ["children", "className", "disabled", "disabledClassName", "focus", "id", "hidden", "panelId", "selected", "selectedClassName", "tabRef"]);
            return _react2.default.createElement("li", Object.assign({}, attributes, { className: (0, _classnames3.default)(className, (_classnames = {}, _defineProperty(_classnames, selectedClassName, selected), _defineProperty(_classnames, disabledClassName, disabled), _classnames)), ref: function ref(node) {
                    _this2.node = node;
                    if (tabRef) tabRef(node);
                }, role: "tab", id: id, "aria-selected": selected ? 'true' : 'false', "aria-disabled": disabled ? 'true' : 'false', "aria-controls": panelId, tabIndex: selected ? '0' : null, "aria-hidden": hidden }), _react2.default.createElement("a", { className: "luna-tab__action", role: "presentation" }, children));
        }
    }]);

    return Tab;
}(_react.Component);

exports.default = Tab;

Tab.defaultProps = {
    className: DEFAULT_CLASS,
    disabledClassName: DEFAULT_CLASS + '--disabled',
    focus: false,
    id: null,
    panelId: null,
    selected: false,
    selectedClassName: DEFAULT_CLASS + '--selected'
};
Tab.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.object, _propTypes2.default.string]).isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
    disabled: _propTypes2.default.bool.isRequired,
    disabledClassName: _propTypes2.default.string,
    focus: _propTypes2.default.bool,
    hidden: _propTypes2.default.bool.isRequired,
    id: _propTypes2.default.string,
    panelId: _propTypes2.default.string,
    selected: _propTypes2.default.bool,
    selectedClassName: _propTypes2.default.string,
    tabRef: _propTypes2.default.func.isRequired
};
//# sourceMappingURL=Tab.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tabs/Tab.js